import * as React from 'react';
import semver from 'semver';

import { Connection as GraphConnection } from 'src/ui/graph/types';
import { useCurrentConnection, useProfile } from 'src/ui/hooks/connection';
import { useOrgDomain } from 'src/ui/hooks/navbar/connection';
import {
  serverVersionFromStatus,
  useConnectionServerStatus,
  voiceboxLimitFromStatus,
} from 'src/ui/hooks/serverStatus';

export const useNavbarSupport = (connectionIdx: string) => {
  const org = useOrgDomain();
  const { data: profileData } = useProfile();
  const { connection } = useCurrentConnection(connectionIdx, org);

  // Shares the single `/admin/status` query with useEndpointVersion and
  // useIsVoiceboxEnabledServer instead of issuing its own identical request.
  const { data: status } = useConnectionServerStatus(
    connection as GraphConnection | null,
    org
  );

  const serverVersion =
    semver.coerce(serverVersionFromStatus(status))?.version || '0.0.0';
  const voiceboxLimit = voiceboxLimitFromStatus(status);

  const isKnowledgeCatalogSupported = semver.gte(serverVersion, '9.0.0');
  const isVoiceboxSupported =
    profileData?.profile?.is_voicebox_enabled &&
    Boolean(voiceboxLimit) &&
    semver.gte(serverVersion, '10.0.0');

  return React.useMemo(
    () => ({
      isKnowledgeCatalogSupported,
      isVoiceboxSupported,
    }),
    [isKnowledgeCatalogSupported, isVoiceboxSupported]
  );
};
